import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FramesetTabs extends ThemeComponent {
    @Ref() heading!: HTMLButtonElement[];
    @Ref() content!: HTMLElement[];

    init() {

        // Add visibility click event listeners
        this.addVisibilityEventListeners();
        this.sizeTable();
        this.sizeTableDesktop();
    }

    addVisibilityEventListeners() {

        // Heading clicks
        if (this.heading) {
            for (const heading of this.heading) {
                this.$listen(heading, 'click', () => {

                    // Handle active classes
                    const headingTabId = heading.getAttribute('data-tab-id');
                    for (const otherHeading of this.heading) {
                        const otherHeadingTabId = otherHeading.getAttribute('data-tab-id');
                        if (otherHeadingTabId === headingTabId) {
                            otherHeading.classList.add('frameset-tabs__heading--active');
                        } else {
                            otherHeading.classList.remove('frameset-tabs__heading--active');
                        }
                    }
                    for (const content of this.content) {
                        const contentTabId = content.getAttribute('data-tab-id');
                        if (headingTabId === contentTabId) {
                            content.classList.add('frameset-tabs__content--active');
                            content.classList.add('frameset-tabs__content--mobile-active');
                        } else {
                            content.classList.remove('frameset-tabs__content--active');
                            content.classList.remove('frameset-tabs__content--mobile-active');
                        }
                    }

                    // Scroll to heading
                    this.scrollToHeading(heading);
                });
            }
        }

    }

    scrollToHeading(heading: HTMLButtonElement) {
        heading.scrollIntoView(true);
    }

    // for the mobile size table
    sizeTable() {
        const tableHeaders = this.querySelectorAll('.table-header');
        const allTableValues = this.querySelectorAll('.table-value');

        if (tableHeaders.length && allTableValues.length) {
            let index = 0;
            for (const header of tableHeaders) {
                const currentIndex = index + 1; // `.value-1`, `.value-2`, etc.

                header.addEventListener('click', () => {
                    // 1. Reset header active classes
                    for (const h of tableHeaders) {
                        h.classList.remove('active');
                    }
                    header.classList.add('active');

                    // 2. Remove all active from all table-values
                    for (const value of allTableValues) {
                        value.classList.remove('active');
                    }

                    // 3. Add active to all `.value-{currentIndex}`
                    const matchingValues = this.querySelectorAll(`.table-value.value-${currentIndex}`);
                    for (const match of matchingValues) {
                        match.classList.add('active');
                    }
                });

                index++;
            }
        }
    }

    sizeTableDesktop() {
        const headers = this.querySelectorAll<HTMLTableCellElement>('.frameset-tabs-whats-included__table th');
        const rows = this.querySelectorAll<HTMLTableRowElement>('.frameset-tabs-whats-included__table--scroll tr');

        for (const [i, header] of Array.from(headers).entries()) {
            const colIndex = i + 1; // match .value--N where N starts at 1

            header.addEventListener('mouseenter', () => {
                highlightColumn(colIndex, true);
            });

            header.addEventListener('mouseleave', () => {
                highlightColumn(colIndex, false);
            });
        }

        for (let i = 1; i <= headers.length; i++) {
            const valueCells = this.querySelectorAll<HTMLElement>(`.value--${i}`);

            for (const cell of valueCells) {
                cell.addEventListener('mouseenter', () => {
                    headers[i - 1]?.classList.add('hovered');
                });

                cell.addEventListener('mouseleave', () => {
                    headers[i - 1]?.classList.remove('hovered');
                });
            }
        }

        function highlightColumn(index: number, add: boolean) {
            for (const row of rows) {
                const cell = row.querySelector(`.value--${index}`);
                if (cell) {
                    cell.classList.toggle('hovered', add);
                }
            }
        }
    }


}
